import { Component, Input } from '@angular/core'
import { EluxBreadcrumb } from '@elxjs/ui'

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
  imports: [EluxBreadcrumb],
  standalone: true,
})
export class PageHeaderComponent {
  @Input() breadcrumbRoutes: any[] = []
  @Input() title!: string
}
